import DateInputComponent from './date-input-component';

/***
 * An instance of a calendar input from the angular-ui-bootstrap library.
 */
const dateInput = angular
    .module('FacilityData.Common.DateInput', [])
    .component('dateInput', DateInputComponent)
    .name;

export default dateInput;


// WEBPACK FOOTER //
// ./app/common/date-input/date-input.js